<template>
  <div>
    <b v-if="employeeState == 'showing'"
      ><p class="text-danger" v-if="edited">
        Los cambios no han sido guardados.
        <a href="#" @click.prevent="saveChanges">Guardar.</a>
      </p></b
    >
    <b-button
      class="float-right"
      @click="resetNewEmergencyContacts"
      v-if="edited == true"
      >Descartar cambios</b-button
    >
    <b-table
      responsive
      v-if="emergencyContacts.length > 0"
      :fields="emergencyContactFields"
      :items="emergencyContacts"
      :stacked="'md'"
      hover
      striped
    >
      <template #cell(name)="data">
        <div v-if="editing.id == data.item.id && !data.item.new">
          <b-input type="text" v-model="editing.name" />
        </div>
        <div v-else>
          {{ data.value }}
        </div>
      </template>
      <template #cell(relationship)="data">
        <div v-if="editing.id == data.item.id && !data.item.new">
          <b-input type="text" v-model="editing.relationship" />
        </div>
        <div v-else>
          {{ data.value }}
        </div>
      </template>
      <template #cell(home_telephone)="data">
        <div v-if="editing.id == data.item.id && !data.item.new">
          <b-input type="text" v-model="editing.home_telephone" />
        </div>
        <div v-else>
          {{ data.value }}
        </div>
      </template>
      <template #cell(work_telephone)="data">
        <div v-if="editing.id == data.item.id && !data.item.new">
          <b-input type="text" v-model="editing.work_telephone" />
        </div>
        <div v-else>
          {{ data.value }}
        </div>
      </template>
      <template #cell(mobile_phone)="data">
        <div v-if="editing.id == data.item.id && !data.item.new">
          <b-input type="text" v-model="editing.mobile_phone" />
        </div>
        <div v-else>
          {{ data.value }}
        </div>
      </template>
      <template #cell(actions)="data">
        <div v-if="!data.item.new">
          <div v-if="editing.id == data.item.id">
            <button class="btn btn-link text-primary btn-sm" @click="save">
              Guardar
            </button>
            <button class="btn btn-link text-danger btn-sm" @click="cancel">
              Cancelar
            </button>
          </div>
          <div v-else>
            <button
              class="btn btn-link text-info btn-sm"
              @click="edit(data.item)"
              v-if="!confirmDelete || deleting != data.item.id"
            >
              Editar
            </button>
            <button
              class="btn btn-link text-danger btn-sm"
              @click="destroy(data.item.id)"
            >
              Eliminar
            </button>
            <button
              class="btn btn-link text-primary btn-sm"
              @click="cancelDestroy"
              v-if="confirmDelete && deleting == data.item.id"
            >
              Cancelar
            </button>
          </div>
        </div>
      </template>
    </b-table>
    <b-button
      variant="link"
      v-if="state == 'show' && can('update', 'employees') && !deleted"
      @click="create"
      >Agregar contacto de emergencia</b-button
    >
    <div v-if="state == 'creating'">
      <b-form-group horizontal label="Nombre">
        <b-form-input
          type="text"
          @input="updateEmergencyContact(['name', $event])"
          :value="name"
        ></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Relación">
        <b-form-input
          type="text"
          @input="updateEmergencyContact(['relationship', $event])"
          :value="relationship"
        ></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Teléfono de casa">
        <b-form-input
          type="text"
          @input="updateEmergencyContact(['home_telephone', $event])"
          :value="home_telephone"
        ></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Teléfono del trabajo">
        <b-form-input
          type="text"
          @input="updateEmergencyContact(['work_telephone', $event])"
          :value="work_telephone"
        ></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Teléfono celular">
        <b-form-input
          type="text"
          @input="updateEmergencyContact(['mobile_phone', $event])"
          :value="mobile_phone"
        ></b-form-input>
      </b-form-group>
      <b-button variant="primary" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { Validation } from "../../utils";
export default {
  data() {
    return {
      emergencyContactFields: [
        {
            key: "name",
            label: "Nombre",
        },
        {
            key: "relationship",
            label: "Relación",
        },
        {
            key: "home_telephone",
            label: "Teléfono de casa",
        },
        {
            key: "work_telephone",
            label: "Teléfono del trabajo",
        },
        {
            key: "mobile_phone",
            label: "Teléfono celular",
        },
        {
            key: "actions",
            label: "",
        },
      ],
      editing: {
        id: null,
        name: null,
        relationship: null,
        home_telephone: null,
        work_telephone: null,
        mobile_phone: null,
      },
      confirmDelete: false,
      deleting: null,
    };
  },
  methods: {
    can: (action, resource) => {
      if (permissions === null) return false;
      if (typeof permissions[resource] === "undefined") return false;
      return permissions[resource].includes(action);
    },
    ...mapActions([
      "resetNewEmergencyContacts",
      "saveChanges",
      "editEmergencyContact",
      "deleteEmergencyContact",
    ]),
    ...mapMutations({
      updateEmergencyContact: "updateNewEmergencyContactAttribute",
      create: "creatingEmergencyContact",
    }),
    addIfValid() {
      var validation = this.valid();
      if (validation.valid) this.$store.dispatch("addEmergencyContact");
      else this.$store.dispatch("displayError", validation.messageBag);
    },
    valid() {
      var validator = new Validation();
      validator.rule(this.name != "", "Debe haber un nombre");
      validator.rule(
        this.relationship != "",
        "Se debe especificar la relación con el empleado"
      );
      validator.rule(
        this.home_telephone != "" ||
          this.work_telephone != "" ||
          this.mobile_phone != "",
        "Debe haber al menos una forma de contacto"
      );
      return validator.validate();
    },
    edit(emergencyContact) {
      this.editing = { ...emergencyContact };
    },
    cancel() {
      this.editing.id = null;
      this.editing.name = null;
      this.editing.relationship = null;
      this.editing.home_telephone = null;
      this.editing.work_telephone = null;
      this.editing.mobile_phone = null;
    },
    async save() {
      await this.editEmergencyContact(this.editing);
      this.cancel();
    },
    async destroy(id) {
      if (this.confirmDelete) {
        await this.deleteEmergencyContact(id);
        this.confirmDelete = false;
        this.deleting = null;
      } else {
        this.deleting = id;
        this.confirmDelete = true;
      }
    },
    cancelDestroy() {
      this.confirmDelete = false;
      this.deleting = null;
    },
  },
  computed: {
    ...mapGetters({
      edited: "emergencyContactEdited",
    }),
    ...mapState({
      employeeState: (state) => state.employeeManager.state,
      emergencyContacts: (state) =>
        state.employeeManager.employee.emergencyContacts,
      state: (state) => state.employeeManager.emergencyContactState,
      name: (state) => state.employeeManager.newEmergencyContact.name,
      relationship: (state) =>
        state.employeeManager.newEmergencyContact.relationship,
      home_telephone: (state) =>
        state.employeeManager.newEmergencyContact.home_telephone,
      work_telephone: (state) =>
        state.employeeManager.newEmergencyContact.work_telephone,
      mobile_phone: (state) =>
        state.employeeManager.newEmergencyContact.mobile_phone,
      deleted_at: (state) => state.employeeManager.employee.deleted_at,
    }),
    deleted() {
      return this.deleted_at !== null;
    },
  },
};
</script>
